import api from "../axiosInstance";

export const getChatsHeads = async () => {
  try {
    const response = await api.get("/chat/heads/");
    return response.data.data;
  } catch (e) {
    console.log("Error : " + e.message);
    return e.message;
  }
};
export const readMessages = async (payload) => {
  try {
    const response = await api.put(`/chat/read/`, {
      senderId: `${payload.senderId}`,
    });
    return response.data.data;
  } catch (e) {
    console.log("Error : " + e.message);
    return e.message;
  }
};

export const getChatLists = async (payload) => {
  try {
    // {
    //   "status": "success",
    //   "data": {
    //     "chats": [
    //       {
    //         "_id": "676e9912466380f58b7d5a2f",
    //         "senderId": "6721f09fd6968872baa0520b",
    //         "receiverId": "676e900b17e8d0297dcc88ae",
    //         "type": 0,
    //         "textMessage": "You need any help?",
    //         "isRead": true,
    //         "createdAt": "2024-12-27T12:09:54.495Z",
    //         "updatedAt": "2024-12-27T18:52:07.196Z",
    //         "__v": 0,
    //         "otherUser": {
    //           "_id": "676e900b17e8d0297dcc88ae",
    //           "profilePhoto": null,
    //           "phoneNumber": "+923159482673",
    //           "isverfied": true,
    //           "firstName": "aa",
    //           "lastName": "zzz",
    //           "email": "a@gmail.com",
    //           "dateOfBirth": "2010-01-01T00:00:00.000Z",
    //           "homeTown": "Japan",
    //           "schoolName": null,
    //           "schoolGraduationYear": "2010-01-01",
    //           "sports": null,
    //           "sportsPosition": "Goalkeeper",
    //           "interests": [
    //             "Beauty & Personal"
    //           ],
    //           "isDeleted": true,
    //           "isBlocked": true,
    //           "createdAt": "2024-12-27T11:31:23.748Z",
    //           "updatedAt": "2025-01-05T11:50:44.540Z",
    //           "__v": 16,
    //           "status": 0
    //         }
    //       },
    //       {
    //         "_id": "676e992a466380f58b7d5a3c",
    //         "senderId": "6721f09fd6968872baa0520b",
    //         "receiverId": "676e900b17e8d0297dcc88ae",
    //         "type": 0,
    //         "textMessage": "You need any help?",
    //         "isRead": true,
    //         "createdAt": "2024-12-27T12:10:18.437Z",
    //         "updatedAt": "2024-12-27T18:52:07.196Z",
    //         "__v": 0,
    //         "otherUser": {
    //           "_id": "676e900b17e8d0297dcc88ae",
    //           "profilePhoto": null,
    //           "phoneNumber": "+923159482673",
    //           "isverfied": true,
    //           "firstName": "aa",
    //           "lastName": "zzz",
    //           "email": "a@gmail.com",
    //           "dateOfBirth": "2010-01-01T00:00:00.000Z",
    //           "homeTown": "Japan",
    //           "schoolName": null,
    //           "schoolGraduationYear": "2010-01-01",
    //           "sports": null,
    //           "sportsPosition": "Goalkeeper",
    //           "interests": [
    //             "Beauty & Personal"
    //           ],
    //           "isDeleted": true,
    //           "isBlocked": true,
    //           "createdAt": "2024-12-27T11:31:23.748Z",
    //           "updatedAt": "2025-01-05T11:50:44.540Z",
    //           "__v": 16,
    //           "status": 0
    //         }
    //       }
    //     ],
    //     "paginationInfo": {
    //       "currentPage": 1,
    //       "totalPages": 1,
    //       "totalItems": 2,
    //       "perPage": 10
    //     }
    //   },
    //   "message": "Chats retrieved successfully"
    // }
    const response = await api.get(
      `/chat/?${payload.otherId ? `otherId=${payload.otherId}` : ""}&${
        payload.page ? `page=${payload.page}` : ""
      }&${payload.pageSize ? `pageSize=${payload.pageSize}` : ""}`
    );
    return response.data.data;
  } catch (e) {
    console.log("Error : " + e.message);
    return e.message;
  }
};

export const sendChatMessage = async (payload) => {
  try {
    const response = await api.post("/chat", {
      receiverId: payload.receiverId,
      type: payload.type,
      textMessage: payload.textMessage,
      imageMessage: payload.imageMessage,
    });
    return response.data.data;
  } catch (e) {
    console.log("Error : " + e.message);
    return e.message;
  }
};
